export default __webpack_public_path__ + "a5116e365e431614be518f2d535a6ecc.png";